import "~/misc/common";
import { p } from "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { createConsumer } from "@rails/actioncable";
import { ConnectionInfo } from "~/types/devices";

export default class extends Controller {
  connect() {
    const el = this.element as HTMLDivElement;
    const green = el.dataset.green!;
    const red = el.dataset.red!;

    const consumer = createConsumer();
    consumer.subscriptions.create("ConnectionChannel", {
      connected: function () {
        console.log('ConnectionChannel connected');
        this.perform('really_subscribed');
      },

      disconnected: function () {
        console.log('ConnectionChannel disconnected');
      },

      received: function (data: ConnectionInfo) {
        p(data);
        for (const [key, value] of Object.entries(data.devices)) {
          $('a.' + key + ' img').attr('src', value.length > 0 ? green : red);
          $('a.' + key + ' span').text(value.length > 0 ? "Rendben" : "Nincs");
        }
      }
    });
  }
}
